// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { AbstractTableFilter, AbstractTableFilterSchema } from 'api/gen/AbstractTableFilter';

const requiredPart = t.interface({
  tag: t.literal('NULL'),
  field: t.string,
});

export const NullFilterSchema = excess(t.intersection([AbstractTableFilterSchema.type, requiredPart]));

export interface NullFilter extends t.TypeOf<typeof NullFilterSchema> {}
